export const getFlatItems = (items) =>
  items.flatMap((item, index) => {
    const haveModifiers = item.modifiers && item.modifiers.length > 0;
    return new Array(haveModifiers ? item.quantity : 1).fill({
      ...item,
      modifiers: item.modifiers || [],
      key: `${item.id}_${index}`,
      totalQuantity: !haveModifiers ? item.quantity : 1
    });
  });

export const groupModifiersByParent = (modifiers, showParentModifier) => {
  const groupedModifiers = {};

  modifiers.forEach((modifier) => {
    const parentName = showParentModifier ? modifier.parents?.[0]?.name : 'NoParent';

    if (!groupedModifiers[parentName]) {
      groupedModifiers[parentName] = [];
    }

    groupedModifiers[parentName].push(modifier);
  });

  return groupedModifiers;
};
